// extracted by mini-css-extract-plugin
module.exports = {"ellipseIcon":"components-base-EllipseIcon-EllipseIcon__ellipseIcon--P4pUE"};